export default __webpack_public_path__ + "static/media/solutionset_passed.81d2afbe.svg";